<template>
    <div class="deptDetail">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="info-wrap"
             v-loading="allLoading">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">{{hospitalDetail.hospitalName}}</span>
            </div>
            <el-form label-width="80px"
                     v-loading="loading"
                     class="form-wrap"
                     :inline="true"
                     :model="deptForm"
                     :rules="deptRules"
                     ref="deptForm">
                <el-form-item label="科室类型"
                              prop="type">
                    <el-select v-model="deptForm.type"
                               placeholder="请选择"
                               size="small">
                        <el-option v-for="(item, index) in typeList"
                                   :key="index"
                                   :label="item.dictDataValue"
                                   :value="item.dictDataCode"></el-option>
                    </el-select>
                </el-form-item>
                <div class="form-item">
                    <div>
                        <i class="el-icon-caret-bottom"
                           @click="isSecondShow=!isSecondShow"
                           v-if="deptForm.secondList.length>0"
                           :class="[{'is-reverse': isSecondShow}]"></i>
                        <el-form-item label="一级科室"
                                      prop="first">
                            <el-autocomplete v-model.trim="deptForm.first"
                                             size="small"
                                             :maxlength="50"
                                             value-key="groupName"
                                             :fetch-suggestions="getAllDept"
                                             placeholder="请输入一级科室"
                                             @select="handleDept"></el-autocomplete>
                        </el-form-item>
                    </div>

                    <el-popover placement="bottom-start"
                                popper-class="more-operate-wrap"
                                width="100"
                                :offset="-7"
                                trigger="click">
                        <div class="operate-item disabled-item">
                            添加同等级
                        </div>
                        <div class="operate-item"
                             @click="addSecond()">
                            添加下一级
                        </div>
                        <div class="operate-item"
                             @click="deleteDept('first')">
                            删除
                        </div>
                        <i class="iconfont icon-more"
                           slot="reference"></i>
                    </el-popover>

                </div>
                <div class="form-child-wrap"
                     v-if="isSecondShow&&deptForm.secondList.length>0">
                    <div class="form-child-item"
                         v-for="(item, index) in deptForm.secondList"
                         :key="index">
                        <el-form-item label="二级科室"
                                      :prop="'secondList.' + index + '.second'"
                                      :rules="[{ validator:checkoutSecond, trigger: 'blur' },
                                                { validator:checkoutSecond, trigger: 'change' }]">
                            <el-autocomplete v-model.trim="item.second"
                                             size="small"
                                             :maxlength="50"
                                             value-key="groupName"
                                             :fetch-suggestions="getAllDept"
                                             placeholder="请输入二级科室"
                                             @select="handleDept"></el-autocomplete>
                        </el-form-item>
                        <el-popover placement="bottom-start"
                                    popper-class="more-operate-wrap"
                                    width="100"
                                    :offset="-7"
                                    trigger="click">
                            <div class="operate-item"
                                 @click="addSecond()">
                                添加同等级
                            </div>
                            <div class="operate-item disabled-item">
                                添加下一级
                            </div>
                            <div class="operate-item"
                                 @click="deleteDept('second', index)">
                                删除
                            </div>
                            <i class="iconfont icon-more"
                               slot="reference"></i>
                        </el-popover>
                    </div>
                </div>

            </el-form>

        </div>
        <div class="btn-bottom-wrap">
            <el-button type="warning"
                       size="small"
                       @click="saveForm()">保 存</el-button>
            <el-button type="info"
                       size="small"
                       plain
                       @click="cancelForm()">返 回</el-button>
        </div>
        <el-dialog title=""
                   :visible.sync="isFirstDeptShow"
                   custom-class="dept-dialog"
                   width="300px">
            <div class="title">
                <i class="el-icon-warning-outline"></i>
                <span class="title-text">您确认要删除{{deptForm.first}}吗？</span>
            </div>
            <div class="message">
                删除一级科室时，二级科室将同步删除！
            </div>
            <span slot="footer"
                  class="dialog-footer">
                <el-button size="small"
                           @click="sureDelete('first')">确 认</el-button>
                <el-button size="small"
                           @click="isFirstDeptShow=false">取 消</el-button>

            </span>
        </el-dialog>
        <el-dialog title=""
                   :visible.sync="isSecondDeptShow"
                   custom-class="dept-dialog dept-second-dialog"
                   width="300px">
            <div class="title">
                <i class="el-icon-warning-outline"></i>
                <span class="title-text">您确认要删除{{deleteDeptName}}吗？</span>
            </div>
            <span slot="footer"
                  class="dialog-footer">
                <el-button size="small"
                           @click="sureDelete('second')">确 认</el-button>
                <el-button size="small"
                           @click="isSecondDeptShow=false">取 消</el-button>

            </span>
        </el-dialog>
        <el-dialog title=""
                   :visible.sync="isDeleteErrorShow"
                   custom-class="dept-dialog dept-error-dialog"
                   width="300px">
            <div class="title">
                <i class="el-icon-circle-close"></i>
                <span class="title-text">删除失败！</span>
            </div>
            <div class="message">
                {{deleteDeptName}}已关联医生无法删除！
            </div>
            <span slot="footer"
                  class="dialog-footer">
                <el-button size="small"
                           type="primary"
                           @click="isDeleteErrorShow=false">我知道了</el-button>

            </span>
        </el-dialog>
    </div>
</template>
<style lang="scss">
.dept-dialog {
    .el-dialog__header {
        height: 20px;
        padding: 0 10px;
        background: #fff;
    }
    .el-dialog__headerbtn {
        right: 10px;
        .el-dialog__close {
            color: #ccc;
            font-size: 16px;
        }
    }
    .el-dialog__body {
        padding: 0 26px;
    }
    .el-icon-warning-outline {
        color: #fdab71;
        font-size: 20px;
        vertical-align: top;
    }
    .el-icon-circle-close {
        color: #ec6a69;
        font-size: 20px;
        vertical-align: top;
    }
    .title-text {
        font-size: 14px;
        color: #333;
        font-weight: 600;
        margin-left: 10px;
        display: inline-block;
        vertical-align: top;
        width: 210px;
    }
    .message {
        font-size: 12px;
        color: #666;
        margin-top: 10px;
        padding-left: 30px;
        height: 12px;
        line-height: 12px;
    }
    .el-dialog__footer {
        padding: 18px 20px;
        .el-button {
            padding: 5px 15px;
        }
    }
    .dialog-footer {
        padding-left: 36px;
    }
}
.dept-second-dialog {
    .el-dialog__header {
        height: 27px;
    }
    .title {
        margin-bottom: 15px;
    }
}
.dept-error-dialog {
    .el-dialog__footer {
        text-align: center;
    }
    .dialog-footer {
        padding-left: 0;
    }
}
.more-operate-wrap {
    padding: 0;
    min-width: 100px;
    .operate-item {
        padding: 0 10px;
        box-sizing: border-box;
        height: 30px;
        line-height: 30px;
        color: #333;
        font-size: 12px;
        cursor: pointer;
        &:hover {
            background-color: $hover;
        }
    }
    .disabled-item {
        color: $disable-link;
        cursor: not-allowed;
    }
}
.deptDetail {
    .el-input__inner {
        width: 260px;
    }
    .form-item {
        .el-form-item__label {
            cursor: pointer;
        }
    }
}
</style>
<style lang="scss" scoped>
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 80px;
    top: 50px;
    padding: 20px;
    overflow: auto;
}
.title-wrap {
    font-size: 0;
    padding-bottom: 10px;
    margin-bottom: 20px;
    border-bottom: 1px solid $border;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.form-item {
    font-size: 0;
    cursor: pointer;
    display: flex;
    .el-icon-caret-bottom {
        font-size: 12px;
        color: #999;
        vertical-align: middle;
        line-height: 32px;
        transition: transform 0.3s;
        transform: rotateZ(-90deg);
        &.is-reverse {
            transform: rotateZ(0deg);
        }
    }
}
.icon-more {
    font-size: 16px;
    cursor: pointer;
    vertical-align: middle;
    line-height: 32px;
    color: #666;
}
.form-child-wrap {
    padding-left: 30px;
}
</style>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'hospitalList',
    data () {
        const checkDept = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入一级科室！'))
            } else {
                if (value !== this.deptDetail.groupName) {
                    const param = {
                        hospitalId: this.hospitalId,
                        departmentName: value
                    }
                    this.$services.hospital.checkDeptUnique(param).then(res => {
                        if (res.results) {
                            callback()
                        } else {
                            callback(new Error('科室名称重复！'))
                        }
                    })
                } else {
                    callback()
                }
            }
        }
        return {
            hospitalId: this.$route.params.hospitalId,
            deptId: this.$route.params.deptId,
            breadList: [{
                label: '医院管理'
            }, {
                label: '科室列表',
                path: '/hospital/deptList'
            }, {
                label: '科室详情页'
            }],
            hospitalDetail: '',
            allLoading: true,
            loading: true,
            typeList: [],
            deptForm: {
                type: '',
                first: '',
                secondList: []
            },
            deptRules: {
                type: [{ required: true, message: '请选择科室类型!', trigger: 'change' }],
                first: [{ required: true, validator: checkDept, trigger: 'blur' },
                        { required: true, validator: checkDept, trigger: 'change' }]
            },
            isSecondShow: false,
            deptDetail: {
                children: []
            },
            isFirstDeptShow: false,
            isSecondDeptShow: false,
            isDeleteErrorShow: false,
            deleteDeptName: '',
            deleteIndex: null
        }
    },
    computed: {
        ...mapGetters([
            'dictionary',
            'userInfo'
        ])
    },
    methods: {
        checkoutSecond (rule, value, callback) {
            if (value) {
                if (this.deptDetail.children.findIndex(n => n.groupName === value) === -1) {
                    const param = {
                        hospitalId: this.hospitalId,
                        departmentName: value
                    }
                    this.$services.hospital.checkDeptUnique(param).then(res => {
                        if (res.results) {
                            callback()
                        } else {
                            callback(new Error('科室名称重复！'))
                        }
                    })
                } else {
                    callback()
                }
            } else {
                callback()
            }
        },
        async submit () {
            let list = []
            // 一级科室
            list.push({
                departmentLevel: 1,
                departmentType: this.deptForm.type,
                groupId: this.deptDetail.groupId ? this.deptDetail.groupId : '',
                groupName: this.deptForm.first,
                hospitalId: this.hospitalId,
                hospitalName: this.hospitalDetail.hospitalName,
                creator: this.userInfo.accountName
            })
            // 二级科室
            this.deptForm.secondList.forEach((item, index) => {
                if (item.second) {
                    list.push({
                        departmentLevel: 2,
                        departmentType: this.deptDetail.children[index].departmentType ? this.deptDetail.children[index].departmentType : this.deptForm.type,
                        groupId: this.deptDetail.children[index].groupId ? this.deptDetail.children[index].groupId : '',
                        groupName: item.second,
                        hospitalId: this.hospitalId,
                        hospitalName: this.hospitalDetail.hospitalName,
                        creator: this.deptDetail.children[index].creator ? this.deptDetail.children[index].creator : this.userInfo.accountName,
                        parentName: this.deptForm.first,
                        parentId: this.deptDetail.groupId ? this.deptDetail.groupId : ''
                    })
                }
            })
            const { results } = await this.$services.hospital.saveDept(list)
            if (results) {
                if (this.deptId === 'add') {
                    this.$message.success('新增成功！')
                } else {
                    this.$message.success('修改成功！')
                }
                this.$router.push('/hospital/deptList')
            }
        },
        saveForm () {
            this.$refs['deptForm'].validate((valid) => {
                if (valid) {
                    this.submit()
                } else {
                    return false
                }
            })
        },
        cancelForm () {
            this.$router.push('/hospital/deptList')
        },
        handleDept (item) {
            console.log(item)
        },
        async getAllDept (queryString, cb) {
            const param = {
                searchName: queryString
            }
            const { results } = await this.$services.hospital.getAllDeptList(param)
            cb(results)
        },
        addSecond () {
            this.deptForm.secondList.push({
                second: ''
            })
            this.deptDetail.children.push({
                groupName: ''
            })
            this.isSecondShow = true
        },
        deleteDept (type, index) {
            if (type === 'first') {
                this.deleteDeptName = this.deptForm.first
                if (this.deptId !== 'add') {
                    const param = {
                        groupId: this.deptDetail.groupId
                    }
                    this.$services.hospital.judgeDeptHaveDoctor(param).then(res => {
                        if (res.results) {
                            this.isFirstDeptShow = true
                        } else {
                            this.isDeleteErrorShow = true
                        }
                    })
                } else {
                    this.isFirstDeptShow = true
                }
            } else if (type === 'second') {
                this.deleteDeptName = this.deptForm.secondList[index].second
                this.deleteIndex = index
                if (this.deptDetail.children[index].groupId) {
                    const param = {
                        groupId: this.deptDetail.children[index].groupId
                    }
                    this.$services.hospital.judgeDeptHaveDoctor(param).then(res => {
                        if (res.results) {
                            this.isSecondDeptShow = true
                        } else {
                            this.isDeleteErrorShow = true
                        }
                    })
                } else {
                    this.isSecondDeptShow = true
                }
            }
        },
        sureDelete (type) {
            if (type === 'first') {
                if (this.deptId !== 'add') {
                    this.$services.hospital.deleteDept(this.deptDetail.groupId).then(res => {
                        if (res.results) {
                            this.$message.success('删除成功！')
                            this.deptDetail = {
                                children: []
                            }
                            this.deptForm.first = ''
                            this.deptForm.type = ''
                            this.deptForm.secondList = []
                            this.isFirstDeptShow = false
                        }
                    })
                } else {
                    this.$message.success('删除成功！')
                    this.deptDetail = {
                        children: []
                    }
                    this.deptForm.first = ''
                    this.deptForm.type = ''
                    this.deptForm.secondList = []
                    this.isFirstDeptShow = false
                }
            } else if (type === 'second') {
                if (this.deptDetail.children[this.deleteIndex].groupId) {
                    this.$services.hospital.deleteDept(this.deptDetail.children[this.deleteIndex].groupId).then(res => {
                        if (res.results) {
                            this.$message.success('删除成功！')
                            this.deptForm.secondList.splice(this.deleteIndex, 1)
                            this.isSecondDeptShow = false
                        }
                    })
                } else {
                    this.deptForm.secondList.splice(this.deleteIndex, 1)
                    this.isSecondDeptShow = false
                }
            }
        },
        async getHospitalDetail () {
            this.allLoading = true
            const { results } = await this.$services.hospital.getHospitalDetail(this.hospitalId)
            this.hospitalDetail = results
            this.allLoading = false
            if (this.deptId === 'add') {
                this.loading = false
            } else {
                this.getDeptDetail()
            }
        },
        async getDeptDetail () {
            this.loading = true
            const { results } = await this.$services.hospital.getDeptDetail(this.deptId)
            this.deptDetail = results
            this.deptForm.type = this.deptDetail.departmentType
            this.deptForm.first = this.deptDetail.groupName
            if (this.deptDetail.children) {
                this.isSecondShow = true
            }
            this.deptDetail.children.forEach(item => {
                this.deptForm.secondList.push({
                    second: item.groupName
                })
            })
            this.loading = false
        }
    },
    created () {
        this.typeList = this.dictionary.KSDJ
        this.getHospitalDetail()
    }
}
</script>
